var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaLivre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4286 1.42857C16.9969 1.42857 17.5419 1.65434 17.9438 2.0562C18.3457 2.45806 18.5714 3.00311 18.5714 3.57143V7.14286H14.2857V12.8571H20V3.57143C20 2.62423 19.6237 1.71582 18.954 1.04605C18.2842 0.376274 17.3758 0 16.4286 0H3.57143C2.62423 0 1.71582 0.376274 1.04605 1.04605C0.376274 1.71582 0 2.62423 0 3.57143V12.8571H5.71429V7.14286H1.42857V3.57143C1.42857 3.00311 1.65434 2.45806 2.0562 2.0562C2.45806 1.65434 3.00311 1.42857 3.57143 1.42857H16.4286ZM0 16.4286V14.2857H5.71429V20H3.57143C2.62423 20 1.71582 19.6237 1.04605 18.954C0.376274 18.2842 0 17.3758 0 16.4286ZM12.8571 14.2857H7.14286V20H12.8571V14.2857ZM7.14286 7.14286V12.8571H12.8571V7.14286H7.14286ZM14.2857 20V14.2857H20V16.4286C20 17.3758 19.6237 18.2842 18.954 18.954C18.2842 19.6237 17.3758 20 16.4286 20H14.2857Z",
    fill: "#5AB2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaLivre);
export default __webpack_public_path__ + "static/media/area_livre.f9e46712976d81703d1f4ac4f0e62c2c.svg";
export { ForwardRef as ReactComponent };